import React from 'react';
import PropTypes from 'prop-types';

const Fax = props => <span>{props.data.fax}</span>;

Fax.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Fax;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/fax.js